import { render, staticRenderFns } from "./CompItemReqStatusGrid.vue?vue&type=template&id=6915928e"
import script from "./CompItemReqStatusGrid.vue?vue&type=script&lang=js"
export * from "./CompItemReqStatusGrid.vue?vue&type=script&lang=js"
import style0 from "./CompItemReqStatusGrid.vue?vue&type=style&index=0&id=6915928e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports